const debug = require('debug')('OD::Lib:SportHelper')

const libLogs = true

const volleyballBase = {
  type: 'pointBase',
  sport: 'volleyball',
  name: 'volleyball',
  numSetsToWin: 3,
  numSetsToPlay: 3,
  regularSetPointsToWin: 25,
  lastSetPointsToWin: 15,
  setMinDifferenteToWin: 2,
  maxNumSets: 5,
  downtimeBySet: 2,
  numChangesBySet: 6,
  maxPlayerNum: 22,
  numPlayerInSet: 6,
  numExtraPlayerInSet: 2,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'volleyball_serve',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'volleyball_attack',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'volleyball_blockout',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'volleyball_block',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'volleyball_serve_error',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_attack_error',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_reception_error',
      icon: '',
      opposite: true,
      num: 1,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_error',
      icon: '',
      opposite: true,
      num: 1,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_net',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_doubles',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_rotation_error',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'volleyball_red_card',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
  ],
  pointBasicControls: [
    {
      code: 'volleyball_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'volleyball_timeout',
      icon: '',
      color: 'brown',
      action: 'downtime',
    },
    {
      code: 'volleyball_change',
      icon: '',
      color: 'blue',
      action: 'change',
      needExtraPlayer: true,
    },
    {
      code: 'volleyball_yellow_card',
      icon: '',
      color: 'orange',
      action: 'yellow_card',
    },
  ],
  actionBasicControls: [],
  timeControls: [],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const badmintonBase = {
  type: 'pointBase',
  sport: 'badminton',
  name: 'badminton',
  numSetsToWin: 2,
  numSetsToPlay: 2,
  regularSetPointsToWin: 21,
  lastSetPointsToWin: 21,
  setMinDifferenteToWin: 2,
  maxSetScore: 30,
  maxNumSets: 3,
  downtimeBySet: 2,
  numChangesBySet: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 2,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'badminton_serve',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'badminton_attack',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'badminton_serve_error',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
    {
      code: 'badminton_attack_error',
      icon: '',
      num: 1,
      opposite: true,
      action: 'point',
      color: 'red',
    },
  ],
  pointBasicControls: [
    {
      code: 'badminton_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'badminton_timeout',
      icon: '',
      color: 'brown',
      action: 'downtime',
    },
  ],
  actionBasicControls: [],
  timeControls: [],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const rugbyBase = {
  type: 'timeBase',
  sport: 'rugby',
  name: 'rugby',
  numPeriods: 2,
  numMinutesPerPeriod: 40,
  numMinutesForLastPeriod: 40,
  numPeriodsPerGroup: 1,
  numDownTimesPerGroupPeriod: 0,
  numChangesBySet: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 23,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'rugby_conversion',
      icon: '',
      num: 2,
      action: 'point',
      color: 'green',
    },
    {
      code: 'rugby_penalty_kick',
      icon: '',
      num: 3,
      action: 'point',
      color: 'green',
    },
    {
      code: 'rugby_drop_goal',
      icon: '',
      num: 3,
      action: 'point',
      color: 'green',
    },
    {
      code: 'rugby_penalty_try',
      icon: '',
      num: 5,
      action: 'point',
      color: 'green',
    },
    {
      code: 'rugby_try',
      icon: '',
      num: 5,
      action: 'point',
      color: 'green',
    },
  ],
  pointBasicControls: [
    {
      code: 'rugby_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'rugby_yellow_card',
      icon: '',
      color: 'orange',
      action: 'yellow-card',
    },
    {
      code: 'rugby_red_card',
      icon: '',
      color: 'red',
      action: 'red-card',
    },
  ],
  actionBasicControls: [],
  timeControls: [
    {
      icon: 'play_arrow',
      color: 'orange',
      action: 'start',
    },
    /*
    {
      icon: 'pause',
      color: 'orange',
      action: 'pause',
    },
    */
    {
      icon: 'stop',
      color: 'orange',
      action: 'stop',
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const soccerBase = {
  type: 'timeBase',
  sport: 'soccer',
  name: 'soccer',
  numPeriods: 2,
  numMinutesPerPeriod: 45,
  numMinutesForLastPeriod: 45,
  numPeriodsPerGroup: 1,
  numDownTimesPerGroupPeriod: 0,
  numChangesBySet: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 11,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'soccer_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'soccer_penalty_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'soccer_fault_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  pointBasicControls: [
    {
      code: 'soccer_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'soccer_yellow_card',
      icon: '',
      color: 'orange',
      action: 'yellow-card',
    },
    {
      code: 'soccer_red_card',
      icon: '',
      color: 'red',
      action: 'red-card',
    },
  ],
  actionBasicControls: [],
  timeControls: [
    {
      icon: 'play_arrow',
      color: 'orange',
      action: 'start',
    },
    /*
    {
      icon: 'pause',
      color: 'orange',
      action: 'pause',
    },
    */
    {
      icon: 'stop',
      color: 'orange',
      action: 'stop',
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const indoorSoccerBase = {
  type: 'timeBase',
  sport: 'indoor_soccer',
  name: 'indoor_soccer',
  numPeriods: 2,
  numMinutesPerPeriod: 20,
  numMinutesForLastPeriod: 20,
  numPeriodsPerGroup: 1,
  numDownTimesPerGroupPeriod: 1,
  numChangesBySet: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 5,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 5,
  pointControls: [
    {
      code: 'soccer_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'soccer_penalty_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'soccer_double_penalty_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'soccer_fault_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  pointBasicControls: [
    {
      code: 'soccer_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'soccer_timeout',
      icon: '',
      color: 'brown',
      action: 'downtime',
    },
    {
      code: 'soccer_change',
      icon: '',
      color: 'blue',
      action: 'change',
      needExtraPlayer: true,
    },
    {
      code: 'soccer_fault',
      icon: '',
      color: 'red',
      action: 'fault',
    },
    {
      code: 'soccer_yellow_card',
      icon: '',
      color: 'orange',
      action: 'yellow-card',
    },
    {
      code: 'soccer_red_card',
      icon: '',
      color: 'red',
      action: 'red-card',
    },
  ],
  actionBasicControls: [],
  timeControls: [
    {
      icon: 'play_arrow',
      color: 'orange',
      action: 'start',
    },
    /*
    {
      icon: 'pause',
      color: 'orange',
      action: 'pause',
    },
    */
    {
      icon: 'stop',
      color: 'orange',
      action: 'stop',
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const baseballBase = {
  type: 'baseballBase',
  sport: 'softball',
  name: 'softball',
  minNumInnings: 9,
  maxPlayerNum: 99,
  numPlayerInSet: 9,
  numExtraPlayerInSet: 1,
  downtimeBySet: 0,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'baseball_run',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'baseball_hit',
      icon: '',
      num: 0,
      action: 'hit',
      color: 'orange',
    },
    {
      code: 'baseball_error',
      icon: '',
      num: 0,
      action: 'error',
      color: 'red',
    },
  ],
  pointBasicControls: [
    {
      code: 'baseball_run',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'baseball_strike',
      icon: '',
      color: 'orange',
      action: 'strike',
      eventHide: true,
    },
    {
      code: 'baseball_ball',
      icon: '',
      color: 'blue',
      action: 'ball',
      eventHide: true,
    },
    {
      code: 'baseball_out',
      icon: '',
      color: 'red',
      action: 'out',
      eventHide: true,
    },
    {
      code: 'baseball_base_by_ball',
      icon: '',
      color: 'blue',
      action: 'basebyball',
      controlHide: true,
    },
    {
      code: 'baseball_stroke_out',
      icon: '',
      color: 'red',
      action: 'strokeout',
      controlHide: true,
    },
  ],
  actionBasicControls: [
    {
      code: 'baseball_3outs',
      icon: '',
      color: 'red',
      action: '3outs',
      eventHide: true,
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const basketballBase = {
  type: 'timeBase',
  sport: 'basketball',
  name: 'basketball',
  numPeriods: 4,
  numMinutesPerPeriod: 15,
  numMinutesForLastPeriod: 15,
  numPeriodsPerGroup: 2,
  numDownTimesPerGroupPeriod: 2,
  numChangesBySet: 0,
  hideDowntimes: true,
  needExtraPeriodsOnDraw: true,
  maxNumExtraPeriods: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 5,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 5,
  pointControls: [
    {
      code: 'basketball_1points',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'basketball_2points',
      icon: '',
      num: 2,
      action: 'point',
      color: 'green',
    },
    {
      code: 'basketball_3points',
      icon: '',
      num: 3,
      action: 'point',
      color: 'green',
    },
  ],
  pointBasicControls: [
    {
      code: 'basketball_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'basketball_block',
      icon: '',
      num: 0,
      action: 'action',
      color: 'purple',
    },
    {
      code: 'basketball_assist',
      icon: '',
      num: 0,
      action: 'action',
      color: 'purple',
    },
    {
      code: 'basketball_rebound',
      icon: '',
      num: 0,
      action: 'action',
      color: 'purple',
    },
    {
      code: 'basketball_fault',
      icon: '',
      color: 'orange',
      action: 'fault',
    },
    {
      code: 'basketball_technical_fault',
      icon: '',
      color: 'red',
      action: 'fault',
    },
    {
      code: 'basketball_change',
      icon: '',
      color: 'blue',
      action: 'change',
      needExtraPlayer: true,
    },
    {
      code: 'basketball_timeout',
      icon: '',
      color: 'brown',
      action: 'downtime',
    },
  ],
  actionBasicControls: [],
  timeControls: [
    {
      icon: 'play_arrow',
      color: 'orange',
      action: 'start',
    },
    /*
    {
      icon: 'pause',
      color: 'orange',
      action: 'pause',
    },
    */
    {
      icon: 'stop',
      color: 'orange',
      action: 'stop',
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

const handballBase = {
  type: 'timeBase',
  sport: 'handballBase',
  name: 'handballBase',
  numPeriods: 2,
  numMinutesPerPeriod: 30,
  numMinutesForLastPeriod: 30,
  numPeriodsPerGroup: 1,
  numDownTimesPerGroupPeriod: 2,
  numChangesBySet: 0,
  maxPlayerNum: 99,
  numPlayerInSet: 7,
  numExtraPlayerInSet: 0,
  maxFaultsBySet: 0,
  pointControls: [
    {
      code: 'handball_goal',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'handball_goal_7m',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
    {
      code: 'handball_goal_9m',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  pointBasicControls: [
    {
      code: 'handball_point',
      icon: '',
      num: 1,
      action: 'point',
      color: 'green',
    },
  ],
  actionControls: [
    {
      code: 'handball_fault',
      icon: '',
      color: 'orange',
      action: 'fault',
    },
    {
      code: 'handball_fault_7m',
      icon: '',
      color: 'orange',
      action: 'fault',
    },
    {
      code: 'handball_fault_9m',
      icon: '',
      color: 'orange',
      action: 'fault',
    },
    {
      code: 'handball_exclusion_2m',
      icon: '',
      color: 'red',
      action: 'fault',
    },
    {
      code: 'handball_expulsion',
      icon: '',
      color: 'red',
      action: 'fault',
    },
    {
      code: 'handball_change',
      icon: '',
      color: 'blue',
      action: 'change',
      needExtraPlayer: true,
    },
    {
      code: 'handball_timeout',
      icon: '',
      color: 'brown',
      action: 'downtime',
    },
  ],
  actionBasicControls: [],
  timeControls: [
    {
      icon: 'play_arrow',
      color: 'orange',
      action: 'start',
    },
    /*
    {
      icon: 'pause',
      color: 'orange',
      action: 'pause',
    },
    */
    {
      icon: 'stop',
      color: 'orange',
      action: 'stop',
    },
  ],
  globalControls: [
    {
      icon: 'remove',
      color: 'red',
      action: 'remove',
    },
  ],
}

export default {
  legacyTransformation(sport) {
    switch (sport) {
      case '6vuG0ue6Zm6laM3sVNCB':
        sport = 'volleyball_federate_3sets'
        break
      case 'HHYz8qkU1WutHr8LHPIy':
        sport = 'volleyball_municipal_3sets'
        break
      case 'Xt2Tcyab6jp0g0BJCBMS':
        sport = 'volleyball_federate_5sets'
        break
    }
    if (sport) sport = sport.replace('voleyball', 'volleyball')
    return sport
  },
  getClubSportList() {
    return [
      'volleyball',
      'badminton',
      'rugby',
      'soccer',
      'indoor_soccer',
      'baseball',
      'softball',
      'basketball',
      'handball',
    ]
  },
  getSportList() {
    return [
      'volleyball_federate_5sets',
      'volleyball_federate_3sets',
      'volleyball_federate_3sets_25',
      'volleyball_municipal_3sets',
      'volleyball_municipal_3sets_25',
      'volleyball_2sets_25',
      'badminton_3sets_21',
      'badminton_3sets_15',
      'rugby_union',
      'rugby_seven',
      'soccer_11players',
      'soccer_7players',
      'indoor_soccer_basic',
      'baseball',
      'softball',
      'basketball',
      'handball',
    ]
  },
  getSportConfiguration(sport) {
    if (libLogs) debug('getSportConfig', sport)

    // Legacy
    sport = this.legacyTransformation(sport)

    switch (sport) {
      case 'volleyball':
      case 'volleyball_federate_5sets':
        return Object.assign({}, volleyballBase, { name: 'volleyball_federate_5sets' })
      case 'volleyball_federate_3sets':
        return Object.assign({}, volleyballBase, {
          name: 'volleyball_federate_3sets',
          numSetsToWin: 2,
          numSetsToPlay: 2,
          maxNumSets: 3,
        })
      case 'volleyball_federate_3sets_25':
        return Object.assign({}, volleyballBase, {
          name: 'volleyball_federate_3sets_25',
          numSetsToWin: 2,
          numSetsToPlay: 2,
          maxNumSets: 3,
          lastSetPointsToWin: 25,
        })
      case 'volleyball_municipal_3sets':
        return Object.assign({}, volleyballBase, {
          name: 'volleyball_municipal_3sets',
          numSetsToWin: 2,
          numSetsToPlay: 3,
          maxNumSets: 3,
        })
      case 'volleyball_municipal_3sets_25':
        return Object.assign({}, volleyballBase, {
          name: 'volleyball_municipal_3sets_25',
          numSetsToWin: 2,
          numSetsToPlay: 3,
          maxNumSets: 3,
          lastSetPointsToWin: 25,
        })
      case 'volleyball_2sets_25':
        return Object.assign({}, volleyballBase, {
          name: 'volleyball_2sets_25',
          numSetsToWin: 2,
          numSetsToPlay: 2,
          maxNumSets: 2,
          lastSetPointsToWin: 25,
        })
      case 'badminton':
      case 'badminton_3sets_21':
        return Object.assign({}, badmintonBase, { name: 'badminton_3sets_21' })
      case 'badminton_3sets_15':
        return Object.assign({}, badmintonBase, {
          name: 'badminton_3sets_15',
          regularSetPointsToWin: 15,
          lastSetPointsToWin: 15,
          setMinDifferenteToWin: 2,
          maxSetScore: 21,
        })
      case 'rugby':
      case 'rugby_union':
        return Object.assign({}, rugbyBase, { name: 'rugby_union' })
      case 'rugby_seven':
        return Object.assign({}, rugbyBase, {
          name: 'rugby_seven',
          numMinutesPerPeriod: 10,
          numMinutesForLastPeriod: 10,
          numPlayerInSet: 14,
          numExtraPlayerInSet: 0,
        })
      case 'soccer':
      case 'soccer_11players':
        return Object.assign({}, soccerBase, { name: 'soccer_11players' })
      case 'soccer_7players':
        return Object.assign({}, soccerBase, { name: 'soccer_7players' })
      case 'indoor_soccer':
      case 'indoor_soccer_basic':
        return Object.assign({}, indoorSoccerBase, {
          name: 'indoor_soccer_basic',
          numMinutesPerPeriod: 20,
          numMinutesForLastPeriod: 20,
          numPlayerInSet: 5,
          numExtraPlayerInSet: 0,
        })
      case 'baseball':
        return Object.assign({}, baseballBase, { sport: 'baseball', name: 'baseball' })
      case 'softball':
        return Object.assign({}, baseballBase, {
          sport: 'softball',
          name: 'softball',
          minNumInnings: 7,
        })
      case 'basketball':
        return Object.assign({}, basketballBase, { sport: 'basketball', name: 'basketball' })
      case 'handball':
        return Object.assign({}, handballBase, { sport: 'handball', name: 'handball' })
      default:
        debug('getSportConfiguration', 'ERROR: Sport not found', sport)
        return null
    }
  },
}
